import { render, staticRenderFns } from "./PageSection.vue?vue&type=template&id=175a7803&"
import script from "./PageSection.vue?vue&type=script&lang=ts&"
export * from "./PageSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports